﻿/*! @preserve start */
; (() => {
    /* =====================================================
       PARALLAX BACKGROUND
       ===================================================== */
    const section = document.getElementById("product-features");
    if (section) {
        const grid = section.querySelector(".bg-grid");
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (grid && !reduceMotion) {
            const intensity = 0.15;
            let ticking = false;

            function update() {
                const rect = section.getBoundingClientRect();
                const offset = rect.top * intensity;
                grid.style.setProperty("--parallax-y", offset.toFixed(2) + "px");
                ticking = false;
            }

            function onScroll() {
                if (ticking) return;
                ticking = true;
                requestAnimationFrame(update);
            }

            update();
            window.addEventListener("scroll", onScroll, { passive: true });
            window.addEventListener("resize", onScroll);
        }
    }

    /* =====================================================
       FEATURE CARD MODAL SYSTEM
       ===================================================== */
    function initFeaturesModal() {
        if (!section || section.dataset.init === "true") return;
        section.dataset.init = "true";

        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const backdrop = section.querySelector(".feature-backdrop");

        let activeCard = null;
        let morph = null;

        function lockScroll(lock) {
            document.documentElement.style.overflow = lock ? "hidden" : "";
        }

        function vw() {
            return window.innerWidth || document.documentElement.clientWidth;
        }
        function vh() {
            return window.innerHeight || document.documentElement.clientHeight;
        }
        function isMobile() {
            return vw() < 576;
        }

        function measureContentHeight(title, html, width) {
            const probe = document.createElement("div");
            probe.style.cssText = `position:fixed;left:-99999px;top:0;visibility:hidden;z-index:-1;background:#fff;width:${width}px;border-radius:16px;`;
            probe.innerHTML = `<div class="feature-morph-inner" style="opacity:1;max-height:none;overflow:visible;padding:24px 28px;">
          <button class="fm-x" type="button">×</button>
          <h3 class="fm-title">${title}</h3>
          <div class="fm-body">${html}</div>
        </div>`;

            document.body.appendChild(probe);
            const height = probe.firstElementChild.scrollHeight + 8;
            probe.remove();
            return height;
        }

        function targetRect(title, html) {
            if (isMobile()) {
                return { left: 0, top: 0, width: vw(), height: vh(), mobile: true };
            }

            const width = Math.min(900, Math.round(vw() * 0.92));
            const height = Math.min(
                measureContentHeight(title, html, width),
                Math.round(vh() * 0.9)
            );

            return {
                left: (vw() - width) / 2,
                top: (vh() - height) / 2,
                width,
                height,
                mobile: false,
            };
        }

        function applyRect(el, r) {
            el.style.top = r.top + "px";
            el.style.left = r.left + "px";
            el.style.width = r.width + "px";
            el.style.height = r.height + "px";
        }

        function buildInner(modal, title, html) {
            const inner = document.createElement("div");
            inner.className = "feature-morph-inner";
            inner.innerHTML = `<button class="fm-x" type="button">×</button>
           <h3 class="fm-title">${title}</h3>
           <div class="fm-body">${html}</div>`;

            inner.querySelector(".fm-x").onclick = close;
            if (backdrop) backdrop.onclick = close;

            modal.appendChild(inner);
            requestAnimationFrame(() => modal.classList.add("ready"));
        }

        function open(card) {
            activeCard = card;

            const title = card.dataset.title || "";
            const html = card.querySelector("template")?.innerHTML || "";
            const rect = card.getBoundingClientRect();

            card.classList.add("is-ghost");
            if (backdrop) backdrop.classList.add("is-open");
            lockScroll(true);

            morph = document.createElement("div");
            morph.className = "feature-morph-card";
            applyRect(morph, rect);
            document.body.appendChild(morph);

            const t = targetRect(title, html);
            morph.getBoundingClientRect(); // force reflow
            if (t.mobile) morph.classList.add("mobile-full");
            applyRect(morph, t);

            morph.addEventListener(
                "transitionend",
                () => buildInner(morph, title, html),
                { once: true }
            );
        }

        function close() {
            if (backdrop) backdrop.classList.remove("is-open");
            lockScroll(false);
            if (activeCard) activeCard.classList.remove("is-ghost");
            if (morph) morph.remove();
        }

        section.addEventListener("click", (e) => {
            const card = e.target.closest(".feature-card");
            if (card) open(card);
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") close();
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initFeaturesModal);
    } else {
        initFeaturesModal();
    }
})();
/*! @preserve end */
